import { styled } from '@mui/material/styles';

export const DataGridContainer = styled('div')(() => ({
  width: '100%',
  height: '100%',
  overflow: 'scroll',
}));
